import firebase from "./firebase-config";

import { OAuthProvider } from "firebase/auth";

export const microsoftprovider = new OAuthProvider("microsoft.com");
export const googleprovider = new firebase.auth.GoogleAuthProvider();
